/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Icon97IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Icon97Icon(props: Icon97IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 32 32"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M15.66 2.06a1 1 0 0 1 .787.045l14 7a1 1 0 0 1 0 1.79l-14 7a1 1 0 0 1-.894 0l-14-7a1 1 0 0 1 0-1.79l14-7zM4.236 10 16 15.882 27.764 10 16 4.118z"
        }
      ></path>

      <path
        fill={"currentColor"}
        d={
          "M5 23V12a1 1 0 1 1 2 0v11c0 .798.673 1.789 2.376 2.64C11.02 26.463 13.36 27 16 27s4.98-.538 6.624-1.36C24.327 24.79 25 23.799 25 23V12a1 1 0 1 1 2 0v11c0 1.963-1.566 3.472-3.481 4.43C21.543 28.418 18.883 29 16 29s-5.543-.582-7.519-1.57C6.566 26.472 5 24.963 5 23m24-2v-7a1 1 0 1 1 2 0v7a1 1 0 1 1-2 0"
        }
      ></path>
    </svg>
  );
}

export default Icon97Icon;
/* prettier-ignore-end */
